<template>
  <div class="row">
    <!-- Header -->
    <div class="col-12 mb-4">
      <div class="d-flex align-items-center justify-content-between flex-wrap">
        <div>
          <button @click="back" class="btn btn-sm btn-outline-secondary mb-2">
            <i class="mdi mdi-arrow-left mr-1"></i>{{ $t('common.back') }}
          </button>
          <h2 class="text-white font-weight-bold mb-1">{{ $t('superadmin.createDiscount') }}</h2>
          <p class="text-muted small mb-0">{{ $t('superadmin.discountsSubtitle') }}</p>
        </div>
      </div>
    </div>

    <div class="col-12 grid-margin">
      <div class="card border-0 shadow-sm" style="background: #191c24; border-radius: 12px;">
        <div class="card-body p-4">
          <form class="forms-sample" @submit.prevent="submitForm">
            <div class="row mb-3">
              <div class="col-md-6 mb-3">
                <label class="text-light small font-weight-bold" for="discount-code">
                  {{ $t('superadmin.discountCode') }} <span class="text-danger">*</span>
                </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-dark border-secondary text-muted"><i class="mdi mdi-ticket-percent-outline"></i></span>
                  </div>
                  <input
                    id="discount-code"
                    type="text"
                    class="form-control bg-dark text-white border-secondary font-monospace"
                    v-model="model.code"
                    :placeholder="$currentLocale === 'id' ? 'Contoh: GAMIPROMO2026' : 'e.g. GAMIPROMO2026'"
                    style="text-transform: uppercase;"
                    required
                  />
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label class="text-light small font-weight-bold" for="title">
                  {{ $t('common.name') }} <span class="text-danger">*</span>
                </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-dark border-secondary text-muted"><i class="mdi mdi-format-title"></i></span>
                  </div>
                  <input
                    id="title"
                    type="text"
                    class="form-control bg-dark text-white border-secondary"
                    v-model="model.title"
                    :placeholder="$currentLocale === 'id' ? 'Contoh: Promo Awal Tahun 25%' : 'e.g. Early Bird Enterprise 25%'"
                    required
                  />
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-md-4 mb-3">
                <label class="text-light small font-weight-bold" for="type">
                  {{ $t('superadmin.discountType') }} <span class="text-danger">*</span>
                </label>
                <select id="type" v-model="model.type" class="form-control bg-dark text-white border-secondary" required>
                  <option value="" disabled>{{ $t('superadmin.discountType') }}</option>
                  <option value="percent">{{ $t('superadmin.percentage') }}</option>
                  <option value="flat">{{ $t('superadmin.flatAmount') }}</option>
                </select>
              </div>

              <div class="col-md-4 mb-3">
                <label class="text-light small font-weight-bold" for="value">
                  {{ $t('superadmin.discountValue') }} <span class="text-danger">*</span>
                </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-dark border-secondary text-muted">
                      {{ model.type === 'flat' ? 'Rp' : '%' }}
                    </span>
                  </div>
                  <input
                    id="value"
                    type="number"
                    class="form-control bg-dark text-white border-secondary"
                    v-model.number="model.value"
                    :placeholder="$currentLocale === 'id' ? 'Contoh: 20' : 'e.g. 20'"
                    min="1"
                    required
                  />
                </div>
              </div>

              <div class="col-md-4 mb-3">
                <label class="text-light small font-weight-bold" for="limit_user">
                  {{ $t('superadmin.usageLimit') }}
                </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-dark border-secondary text-muted"><i class="mdi mdi-account-multiple"></i></span>
                  </div>
                  <input
                    id="limit_user"
                    type="number"
                    class="form-control bg-dark text-white border-secondary"
                    v-model.number="model.limit_user"
                    placeholder="100"
                    min="0"
                  />
                </div>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-6 mb-3">
                <label class="text-light small font-weight-bold" for="expired_at">
                  {{ $t('superadmin.expiryDate') }}
                </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-dark border-secondary text-muted"><i class="mdi mdi-calendar"></i></span>
                  </div>
                  <input
                    id="expired_at"
                    type="date"
                    class="form-control bg-dark text-white border-secondary"
                    v-model="model.expired_at"
                  />
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label class="text-light small font-weight-bold" for="desc">
                  {{ $t('common.description') }}
                </label>
                <input
                  id="desc"
                  type="text"
                  class="form-control bg-dark text-white border-secondary"
                  v-model="model.desc"
                  :placeholder="$currentLocale === 'id' ? 'Syarat atau detail kampanye promo...' : 'Terms or campaign details...'"
                />
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="d-flex justify-content-end align-items-center pt-3 border-top border-secondary">
              <button
                type="button"
                @click="back"
                class="btn btn-outline-secondary px-4 py-2 mr-3"
                :disabled="loading"
              >
                {{ $t('common.cancel') }}
              </button>
              <button
                type="submit"
                class="btn btn-warning px-5 py-2 font-weight-bold text-dark"
                :disabled="loading"
              >
                <span v-if="loading" class="spinner-border spinner-border-sm mr-2" role="status"></span>
                <i v-else class="mdi mdi-check-circle-outline mr-1"></i>
                {{ loading ? $t('common.saving') : $t('common.submit') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import { storeDiscont } from '@/services/discountServices';

export default {
  name: 'CreateDiscountView',
  data: () => ({
    model: {
      title: '',
      desc: '',
      type: 'percent',
      value: 10,
      code: '',
      limit_user: 100,
      expired_at: '',
    },
    loading: false,
  }),
  methods: {
    async submitForm() {
      this.loading = true;
      try {
        if (this.model.code) {
          this.model.code = this.model.code.toUpperCase().trim();
        }
        await storeDiscont(this.model);

        Swal.fire({
          icon: 'success',
          title: this.$t('common.success'),
          text: this.$currentLocale === 'id' ? 'Kode promo diskon berhasil dibuat.' : 'Discount promo code created successfully.',
          confirmButtonColor: '#ffab00',
        });

        this.$router.push({ name: 'discount' });
      } catch (error) {
        const errors = error.response?.data?.errors;
        const errMsg =
          errors && typeof errors === 'object'
            ? Object.values(errors).flat()[0]
            : error.response?.data?.message || error.message || (this.$currentLocale === 'id' ? 'Gagal membuat voucher diskon' : 'Failed to create discount voucher');
        Swal.fire({
          icon: 'error',
          title: this.$t('common.error'),
          text: errMsg,
          confirmButtonColor: '#ffab00',
        });
      } finally {
        this.loading = false;
      }
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>
